// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TableDropdown_wrapper__3vhQU","tableDropdown":"TableDropdown_tableDropdown__leWEe","z":"TableDropdown_z__2gXRB","menuItem":"TableDropdown_menuItem__gYFvR"};